import { render, staticRenderFns } from "./UserSettlementView.vue?vue&type=template&id=05a85917&"
import script from "./UserSettlementView.vue?vue&type=script&lang=js&"
export * from "./UserSettlementView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports